import { useEffect, useState } from 'react'
import { useAvailablePoolsQuery } from 'graphql/v2/generated/types-and-hooks'
import { V2_SUBGRAPH_URLS } from 'config/constants/endpoints'
import { useActiveChainId } from 'hooks/useActiveChainId'
import EchodexTable from 'components/EchodexTable/EchodexTable'
import useSearchPagination from 'hooks/useSearchPagination'
import { getBlockExploreLink } from 'utils'
import Link from 'next/link'
import { formatAmount } from '@echodex/utils/formatInfoNumbers'
import DoubleCurrencyLogo from 'components/Logo/DoubleLogo'
import Pagination from 'components/Pagination/Pagination'
import CircleLoader from 'components/Loader/CircleLoader'
import { convertToCurrency } from 'hooks/useConvertToCurrency'
import { ButtonAdd } from '../../components/Button'

const V2Table = () => {
    const { chainId } = useActiveChainId()
    const [skipPage, setSkipPage] = useState(0)

    const { data: allPoolData, isLoading: loading } = useAvailablePoolsQuery(
        { endpoint: V2_SUBGRAPH_URLS[chainId] },
        { skip: skipPage },
    )
    // const filteredPool = (item, valueDebounce) => {
    //     const currency0 = convertToCurrency(chainId, item.token0)
    //     const currency1 = convertToCurrency(chainId, item.token1)
    //     const pairName = `${currency0.symbol}/${currency1.symbol}`
    //     const resultValueDebounce = valueDebounce.toLowerCase()
    //     return (
    //         pairName.toLowerCase().includes(resultValueDebounce) ||
    //         item.token0.id.toLowerCase().includes(resultValueDebounce) ||
    //         item.token1.id.toLowerCase().includes(resultValueDebounce)
    //     )
    // }

    const { currentPage, currentData, handlePagePlus, handlePageMinus, skip, isDisabled } = useSearchPagination(
        allPoolData ? allPoolData.pairs : undefined,
        10,
    )
    useEffect(() => {
        setSkipPage(skip)
    }, [skip, setSkipPage])
    return (
        <>
            <div className="flex justify-center">{loading && <CircleLoader size="64px" />}</div>
            <EchodexTable thead={THEAD}>
                {!loading &&
                    currentData &&
                    currentData.map((pair) => {
                        return <TableContent key={pair.id} pair={pair} chainId={chainId} />
                    })}
            </EchodexTable>
            <Pagination
                disabledNext={isDisabled}
                currentPage={currentPage}
                handlePagePlus={handlePagePlus}
                handlePageMinus={handlePageMinus}
            />
        </>
    )
}

const TableContent = ({ pair, chainId }) => {
    const currency0 = convertToCurrency(chainId, pair.token0)
    const currency1 = convertToCurrency(chainId, pair.token1)

    let volume24h = 0
    let volume7Days = 0
    for (let i = 0; i < pair.pairHourData.length; i++) {
        if (i <= 24) volume24h += parseFloat(pair.pairHourData[i].hourlyVolumeUSD)
        volume7Days += parseFloat(pair.pairHourData[i].hourlyVolumeUSD)
    }

    return (
        <tr className="even:bg-gray odd:bg-backgroundAlt2">
            <td>
                <div className="pl-4">
                    <a
                        className="gap-1 fa-center"
                        href={getBlockExploreLink(pair.id, 'address', chainId)}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <DoubleCurrencyLogo currency0={currency0} currency1={currency1} size={26} />
                        {`${currency0.symbol}/${currency1.symbol}`}
                    </a>
                </div>
            </td>
            <td>
                <div>
                    {formatAmount(parseFloat(pair.reserve0), { notation: 'standard' })} {currency0.symbol}
                </div>
                <div>
                    {formatAmount(parseFloat(pair.reserve1), { notation: 'standard' })} {currency1.symbol}
                </div>
            </td>
            <td>
                <div>${formatAmount(parseFloat(pair.reserveUSD))}</div>
            </td>
            <td>
                <div>${formatAmount(volume24h)}</div>
            </td>
            <td>
                <div>${formatAmount(volume7Days)}</div>
            </td>
            <td>{Number(pair.currentFee) < 0.05 ? `0 ECP` : `${parseFloat(pair.currentFee).toFixed(2)} ECP`}</td>
            <td>
                <div className="fa-center gap-[8px]">
                    <Link
                        href={`/v2/add/${currency0.wrapped ? currency0.wrapped.address : 'ETH'}/${
                            currency1.wrapped ? currency1.wrapped.address : 'ETH'
                        }`}
                        className="plus bg-gray h-[36px] w-[36px] rounded-xl flex-center cursor-pointer "
                    >
                        <ButtonAdd tooltipText="Add V2 Liquidity" />
                    </Link>
                </div>
            </td>
        </tr>
    )
}

type thead = {
    name: string
    width?: string
}

const THEAD: thead[] = [
    {
        name: 'Pool',
    },
    {
        name: 'Liquidity',
    },
    {
        name: 'Liquidity (USD)',
    },
    {
        name: 'Volume 24H',
    },
    {
        name: 'Volume 7D',
    },
    {
        name: 'Pre-paid Fee available',
    },
    {
        name: 'Action',
    },
]

export default V2Table
